<div class="current">
  <div class="current__head">
    <h3 class="current__title">Current Scan</h3>
    <button *ngIf="lastScan" type="button" class="current-reset" (click)="reset.emit()">Reset</button>
  </div>

  <div class="current-empty" *ngIf="!lastScan; else scanBody">
    Scan a medication to begin.
  </div>

  <ng-template #scanBody>
    <div class="current-med">{{ lastScan!.med.medicationName }}</div>
    <div class="current-dose">{{ lastScan!.med.dosage }}</div>
    <div class="current-badges">
      <app-med-badges [packSize]="lastScan!.med.packSize" [fullPacks]="lastScan!.med.fullPacks"
                      [bagId]="lastScan!.med.bagId" [marking]="lastScan!.med.marking"
                      [doNotSubstitute]="lastScan!.med.doNotSubstitute"></app-med-badges>
    </div>
    <div class="current-meta">
      <span class="current-meta__barcode">{{ lastScan!.med.pickedProductId }}</span>
      <span class="current-meta__time">{{ lastScan!.med.pickedAt | date:'HH:mm:ss' }}</span>
    </div>
    <div class="current-dest">&rarr; Box #{{ lastScan!.basket.basketNumber }} &middot; {{ lastScan!.basket.patientName }}<span
      *ngIf="lastScan!.basket.patientDob"> ({{ lastScan!.basket.patientDob | dob }})</span></div>

    <div class="current-siblings" *ngIf="lastScan!.basket.medications.length > 0">
      <div class="current-siblings__label">Meds in this box</div>
      <ul class="current-siblings__list">
        <li *ngFor="let m of lastScan!.basket.medications; trackBy: trackByMed"
            class="current-sibling"
            [class.current-sibling--picked]="isPicked(m)"
            [class.current-sibling--missing]="m.pickScanStatus === 'Missing'">
          <span class="current-sibling__mark">
            <ng-container *ngIf="isPicked(m)">&#10003;</ng-container>
            <ng-container *ngIf="m.pickScanStatus === 'Missing'">&#10007;</ng-container>
            <ng-container *ngIf="m.pickScanStatus === 'NotPicked'">&#9675;</ng-container>
          </span>
          {{ m.medicationName }}
        </li>
      </ul>
    </div>
  </ng-template>
</div>
